import { types } from 'mobx-state-tree'

export const NodeGroup = types.model('NodeGroup', {
  node_group_id: types.string,
  node_ids: types.array(types.string),
})
